module.exports = __webpack_public_path__ + "img/logo.2ddb0a1a.png";